import React from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Image } from 'react-bootstrap';
import LMDBanner from '../../assets/images/LMDBanner.jpg';
import './Home.css';

const Home: React.FC = () => {
  const location = useLocation();
  const thankYou = location.state?.thankYou;
  console.log("<AOMN>");
  console.log(thankYou);
  return (
    <Container fluid className="p-0">
      
      <div className="banner-container text-center mb-4">
        <Image 
          src={LMDBanner} 
          alt="LMD Banner"
          fluid
          className="banner-image"
        />
      </div>
      {thankYou && (
        <div className="alert alert-success" style={{ margin: '1rem' }}>
          Thank you for contacting us! We will get back to you soon.
        </div>
      )}
      <div className="home">
        {/* <div className="alert-banner">
          <p>ONLINE REGISTRATION IS NOW CLOSED</p>
        </div> */}
        <div className="content">
          <h1>Welcome to Lutefiskman Triathlon. Online registration for 2026 is now closed</h1>
          <div className="event-datetime" role="note" aria-label="Event date and time">
            <span className="event-datetime__label">Event date &amp; time:</span>{' '}
            <span className="event-datetime__value">June 20, 2026 at 9:00 AM</span>
          </div>
          
          <section className="intro">
            <p>
              The <strong>Lutefiskman Triathlon/ 5K</strong> races are family-friendly experiences that take place in early summer 
              and are great athletic events in the Midwest. Conveniently located between Eau Claire and La Crosse, Wisconsin, 
              the beautiful water of Lake Martha will provide scenic views – the perfect ingredient for a very memorable race 
              in the small lakeside town of Osseo, Wisconsin.
            </p>
          </section>

          <section className="race-details">
            <h2>Event Details</h2>
            <p>
              The triathlon includes:
            </p>
            <ul>
              <li>2-mile canoe around Lake Martha</li>
              <li>11-mile bike on the beautiful paved scenic roads of Trempealeau/Jackson Counties</li>
              <li>3 mile run around the Osseo Golf Course</li>
            </ul>
            <p>
              The 5K follows the same run as the triathlon. This is a wonderful introductory triathlon or 5K, 
              yet is still competitive for the veterans.
            </p>
          </section>

          <section className="divisions">
            <h2>Competition Divisions</h2>
            <div className="divisions-container">
              <div className="triathlon-divisions">
                <h3>Triathlon Divisions</h3>
                <ul>
                  <li>Male and Female Solo</li>
                  <li>Male and Female Team</li>
                  <li>Coed Team</li>
                  <li>Relay Team</li>
                  <li>Kids Relay (15 years and younger)</li>
                  <li>Kids Ball and Chain (15 years and younger)</li>
                  <li>Ball & Chain</li>
                  <li>Older than Ole & Lena Team</li>
                </ul>
              </div>
              <div className="k5-divisions">
                <h3>5K Divisions</h3>
                <ul>
                  <li>Male</li>
                  <li>Female</li>
                  <li>Family</li>
                </ul>
              </div>
            </div>
          </section>

          {/* <section className="cta">
            <Link to="/registration" className="register-button">Register Now</Link>
          </section> */}
        </div>
      </div>
    </Container>
  );
};

export default Home; 
